export default {
  data() {
    return {
      ownershipManagement: {},
      accounts: {},
      groups: {},
      hygieneCenter: {},
      data: {},
      myDashboard: {},
      admin: {},
      accountTypeManagement: {},
      intelligentAccounts: {},
      userModules: {},
    };
  },
  mounted() {
    this.userModules = JSON.parse(
      document.getElementById('view-data:ModuleDetails').value
    );
    let dashboardLink = [
      {
        text: 'My Dashboard',
        href: `${this.SbBaseUrl}/Dashboard`,
        icon: 'push_pin',
      },
    ];
    let reportCenterLink = this.getLinks(['ReportCenter']);
    if (reportCenterLink.length > 0) reportCenterLink[0].icon = 'bar_chart';

    this.myDashboard = {
      title: 'My SPHEREboard',
      links: dashboardLink.concat(reportCenterLink),
    };
    this.accounts = {
      title: 'Accounts',
      icon: 'account_circle',
      links: this.getLinks(['Combined_PAM_beta', 'IAM']),
    };
    this.intelligentAccounts = {
      title: 'Accounts',
      icon: 'account_circle',
      links: '',
    };
    this.groups = {
      title: 'Groups',
      icon: 'group',
      links: this.getLinks(['AD']),
    };
    this.admin = {
      links: this.getLinks(['Admin']),
    };
    this.hygieneCenter = {
      title: 'Remediation Center',
      icon: 'rule',
      links: this.getLinks([
        'ARM',
        {
          ModuleName: 'ConfigureVirtualWorkers',
          Title: 'Configure Virtual Workers',
          Policies: 'AnalystRole,AdminRole',
          Link: '/WorkerTemplates#',
        },
      ]),
    };
    this.data = {
      title: 'Data',
      icon: 'snippet_folder',
      links: this.getLinks([
        'ActivityReporter',
        'CloudData',
        'Confluence',
        'UDM_beta',
        {
          ModuleName: 'UDMCollectionException',
          Title: 'UDM Collection Exception',
          Policies: 'AnalystRole,AdminRole',
          Link: '/UDMCollectionException#',
          subLink: 'Unstructured Data',
        },
      ]),
    };
    this.ownershipManagement = {
      title: 'Ownership Management',
      icon: 'manage_accounts',
      links: this.getLinks([
        'HRAutomation',
        'OwnershipAutomation',
        'AOM',
        'UserAccountMappings',
      ]),
    };
    this.accountTypeManagement = {
      title: 'Account Type Management',
      icon: 'manage_accounts',
    };
  },
  methods: {
    getLinks(modules) {
      // Get the list of modules that the user has access to based on their role
      let moduleList = this.userModules;
      let links = [],
        permittedModulePolicies = moduleList.map((m) => m.Policies);
      for (let i = 0; i < modules.length; i++) {
        let moduleDetails = {};
        if (typeof modules[i] == 'object') {
          moduleDetails = modules[i];
        } else {
          moduleDetails = moduleList.find((m) => m.ModuleName === modules[i]);
        }
        if (
          moduleDetails &&
          permittedModulePolicies.includes(moduleDetails.Policies)
        ) {
          if (moduleDetails.subLink) {
            links = links.map((l) => {
              if (l.text == moduleDetails.subLink) {
                if (!l.subLinks) l.subLinks = [];
                l.subLinks.push({
                  text: moduleDetails.Title,
                  href: `${this.SbBaseUrl}${moduleDetails.Link}`,
                });
              }
              return l;
            });
          } else {
            links.push({
              text: moduleDetails.Title,
              href: `${this.SbBaseUrl}${moduleDetails.Link}`,
            });
            if (modules[i] == 'Admin') {
              links[0].icon = moduleDetails.IconText;
            }
          }
        }
      }
      return links;
    },
  },
};
